import { MessageCircle } from "lucide-react";
import { business } from "@/config/business";
import { getWhatsAppUrl } from "@/lib/whatsapp";
import { trackEvent, EVENTS } from "@/lib/tracking";
import { QuoteButton } from "@/components/CtaButtons";
import { Reveal } from "@/components/Reveal";

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden bg-[#0F172A]"
    >
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
        aria-hidden="true"
      />
      {/* accent glow */}
      <div className="absolute -right-24 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full bg-[#25D366]/10 blur-3xl" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8 lg:py-28">
        <div className="max-w-3xl">
          <Reveal>
            <h2 className="text-3xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl lg:text-5xl">
              Jaga Performa AC &amp; HVAC Perusahaan Anda
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
              Rencanakan preventive maintenance sebelum gangguan menghambat
              operasional.
            </p>
          </Reveal>
          <Reveal delay={0.16}>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
              <QuoteButton
                label={business.cta.primary}
                source="final_cta"
                size="lg"
                variant="accent"
                testId="final-quote-cta"
                className="w-full !bg-[#25D366] !text-white hover:!bg-[#1eb85a] sm:w-auto"
              />
              <a
                href={getWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent(EVENTS.WHATSAPP_CLICK, { source: "final_cta" })}
                data-testid="final-whatsapp-cta"
                className="inline-flex w-full items-center justify-center gap-2.5 rounded-lg bg-transparent px-8 py-4 text-base font-bold text-white ring-1 ring-inset ring-white/25 transition-colors hover:bg-white/10 sm:w-auto"
              >
                <MessageCircle className="h-5 w-5" />
                WhatsApp {business.whatsapp.display}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
